/* eslint-disable */
import * as Types from '../../../types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from 'graphql-tag';
export type CrossEntityNotificationsCountQueryVariables = Types.Exact<{
  status?: Types.InputMaybe<Types.NotificationStatus>;
}>;


export type CrossEntityNotificationsCountQuery = { __typename: 'Query', account?: { __typename: 'Account', id: string, allNotificationsForAttachedEntities: { __typename: 'AllNotificationsForAttachedEntitiesResult', totalCount: number } } | null };


export const CrossEntityNotificationsCountDocument = gql`
    query CrossEntityNotificationsCount($status: NotificationStatus) {
  account {
    id
    allNotificationsForAttachedEntities(statusFilter: $status, offset: 0, limit: 1) {
      totalCount
    }
  }
}
    ` as unknown as DocumentNode<CrossEntityNotificationsCountQuery, CrossEntityNotificationsCountQueryVariables>;